import App from './app';
import lang from 'constants/lang';

document.title = lang.APP_TITLE;

export default App;
